// components/MyPage/components/AppearanceSettings.js
import React from "react";
import styled from "styled-components";
import { Save } from "lucide-react";
import { 
  ContentHeader, 
  ContentTitle, 
  Form, 
  FormGroup, 
  Label, 
  Select, 
  SaveButton 
} from "./css";

const ColorOption = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 6px 0;
`;

const ColorSwatch = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background-color: ${props => props.color};
  cursor: pointer;
  border: 2px solid ${props => props.$selected ? '#2563eb' : 'transparent'};
`;

const AppearanceSettings = ({ formData, handleChange, handleColorSelect, handleSubmit }) => {
  return (
    <>
      <ContentHeader>
        <ContentTitle>화면 설정</ContentTitle>
      </ContentHeader>
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <Label>기본 작업 색상</Label>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            <ColorOption>
              <ColorSwatch 
                color="#4EA8DE" 
                $selected={formData.defaultTaskColor === "#4EA8DE"}
                onClick={() => handleColorSelect("#4EA8DE")}
              />
              <span>파랑</span>
            </ColorOption>
            <ColorOption>
              <ColorSwatch 
                color="#8884D8" 
                $selected={formData.defaultTaskColor === "#8884D8"}
                onClick={() => handleColorSelect("#8884D8")}
              />
              <span>보라</span>
            </ColorOption>
            <ColorOption>
              <ColorSwatch 
                color="#82CA9D" 
                $selected={formData.defaultTaskColor === "#82CA9D"}
                onClick={() => handleColorSelect("#82CA9D")}
              />
              <span>초록</span>
            </ColorOption>
            <ColorOption>
              <ColorSwatch 
                color="#FFBB28" 
                $selected={formData.defaultTaskColor === "#FFBB28"}
                onClick={() => handleColorSelect("#FFBB28")}
              />
              <span>노랑</span>
            </ColorOption>
            <ColorOption>
              <ColorSwatch 
                color="#FF8042" 
                $selected={formData.defaultTaskColor === "#FF8042"}
                onClick={() => handleColorSelect("#FF8042")}
              />
              <span>주황</span>
            </ColorOption>
            <ColorOption>
              <ColorSwatch 
                color="#F43F5E" 
                $selected={formData.defaultTaskColor === "#F43F5E"}
                onClick={() => handleColorSelect("#F43F5E")}
              />
              <span>빨강</span>
            </ColorOption>
          </div>
        </FormGroup>
        
        <FormGroup>
          <Label htmlFor="timeFormat">시간 형식</Label>
          <Select 
            id="timeFormat" 
            name="timeFormat" 
            value={formData.timeFormat}
            onChange={handleChange}
          >
            <option value="12h">12시간 (AM/PM)</option>
            <option value="24h">24시간</option>
          </Select>
        </FormGroup>
        
        <FormGroup>
          <Label htmlFor="dateFormat">날짜 형식</Label>
          <Select 
            id="dateFormat" 
            name="dateFormat" 
            value={formData.dateFormat}
            onChange={handleChange}
          >
            <option value="yyyy-MM-dd">YYYY-MM-DD</option>
            <option value="MM/dd/yyyy">MM/DD/YYYY</option>
            <option value="dd/MM/yyyy">DD/MM/YYYY</option>
          </Select>
        </FormGroup>
        
        <SaveButton type="submit">
          <Save size={16} />
          저장
        </SaveButton>
      </Form>
    </>
  );
};

export default AppearanceSettings;